import { InputNumber, Typography, Form } from "antd";

const { Text } = Typography;

export default function SolarRadiationTab({ form }) {
  const values = Form.useWatch("solarRadiation", form) || [];

  const setValues = (updater) => {
    const next =
      typeof updater === "function" ? updater(values) : updater;

    form.setFieldsValue({ solarRadiation: next });
  };

  const handleChange = (hour, value) => {
    setValues((prev) =>
      prev.map((v) =>
        v.hour === hour ? { ...v, radiation: value } : v
      )
    );
  };

  return (
    <div style={{ padding: 16 }}>
      <Form.Item name="solarRadiation" hidden>
        <input />
      </Form.Item>
      {/* Info */}
      <Text type="secondary">
        Solar radiation values are expressed in watts per square meter (W/m²).
      </Text>

      {/* Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 16,
          marginTop: 16,
        }}
      >
        {values.map(({ hour, radiation }) => (
          <div
            key={hour}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text strong>Hour {hour}</Text>

            <InputNumber
              min={0}
              max={2000}
              step={10}
              value={radiation}
              onChange={(val) => handleChange(hour, val)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
